<template>
    <div class="relative md:col-span-4 rounded-lg bg-white shadow-lg hover:shadow-xl overflow-hidden h-full">
        <div class="px-6 py-4">
            <h2 class="text-2xl font-bold text-teal-600">Conversation</h2>
        </div>
        <hr />
        <div ref="msgContainer" class="px-6 pt-6 mb-24 space-y-2 overflow-y-auto overflow-x-hidden" style="height: 500px;">
            <div v-for="message in messages" :key="message.id">
                <div v-if="message.is_sender" class="massege-group space-y-1 ml-0 md:ml-32">
                    <div class="flex flex-no-wrap space-x-4">
                        <div class="flex-1 flex justify-end">
                            <span :class="{ 'opacity-25': message.pending }" class="text-base px-4 py-2 bg-blue-100 rounded">
                                {{ message.body }}
                            </span>
                        </div>
                        <div class="h-10 w-10 rounded-full border-2 border-gray-300">
                            <user-avatar :avatar-url="message.sender.avatar_url" :username="message.sender.name"></user-avatar>
                        </div>
                        <!-- <div
                            class="rounded-full border-2 border-gray-300 bg-cover bg-no-repeat bg-center bg-gray-400 h-10 w-10"
                            style='background-image: url("http://darya.af/img/murtaza_avatar.jpg");'
                        ></div> -->
                    </div>
                </div>
                <div v-else class="massege-group space-y-1 mr-0 md:mr-32">
                    <div class="flex flex-no-wrap space-x-4">
                        <div class="h-10 w-10 rounded-full border-2 border-gray-300">
                            <user-avatar :avatar-url="message.sender.avatar_url" :username="message.sender.name"></user-avatar>
                        </div>
                        <div class="flex-1 flex">
                            <span class="text-base px-4 py-2 bg-blue-100 rounded">{{ message.body }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="time-break flex flex-no-wrap space-x-4 items-center my-10 text-center">
                <hr class="flex-1" />
                <p class="text-sm opacity-75">November 26, 2018</p>
                <hr class="flex-1" />
            </div> -->
        </div>
        <form v-if="form" class="p-4 flex space-x-5 absolute bottom-0 right-0 left-0 bg-gray-100" @submit.prevent="sendMessage">
            <div class="relative flex-1">
                <my-input
                    v-model="form.message"
                    autocomplete="off"
                    name="message"
                    :error="form.errors.get('message')"
                    :autofucos="true"
                    placeholder="Your message"
                />
            </div>
            <my-button :loading="sending" class="btn btn-primary px-6 md:px-8 font-bold" type="submit" progress-text="Sending">
                Send
            </my-button>
        </form>
    </div>
</template>

<script>
import Form from '../../forms/form';

export default {
    props: {
        project: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            form: new Form({
                message: null
            }),
            messages: [],
            sending: false
        };
    },

    mounted() {
        this.fetchMessages();
    },

    methods: {
        fetchMessages() {
            axios.get(`/api/projects/${this.project.slug}/chat/messages`).then(response => {
                this.messages = response.data.data;
                this.scrollToBottom();
                this.initListener();
            });
        },

        sendMessage() {
            if (this.sending || !this.form.message) {
                return;
            }

            this.sending = true;

            axios
                .post(`/api/projects/${this.project.slug}/chat/messages`, {
                    body: this.form.message
                })
                .then(response => {
                    let newMessage = response.data.data;
                    newMessage.is_sender = 1;

                    this.messages.push(newMessage);
                    this.scrollToBottom();
                })
                .catch(() => flash.error())
                .finally(() => {
                    this.sending = false;
                    this.form.message = null;
                });
        },

        scrollToBottom() {
            this.$nextTick(() => (this.$refs.msgContainer.scrollTop = this.$refs.msgContainer.scrollHeight));
        },

        initListener() {
            Echo.private(`mc-chat-conversation.${this.project.conversation_id}`).listen(
                '.Musonza\\Chat\\Eventing\\MessageWasSent',
                e => {
                    this.onMessageReceived(e.message);
                }
            );
        },

        onMessageReceived(message) {
            let newMessage = message;
            newMessage.is_sender = 0;

            this.messages.push(newMessage);
            this.scrollToBottom();
        }
    }
};
</script>
